import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import EditUserPreferences from './../edit/EditUserPreferences';
import Dialog from './Dialog';

class DialogEditUserPreferences extends React.Component {

  constructor (props) {
    super(props);
    this._isMounted = false; // isMounted React pattern to avoid memory leaks
    this.state = {
      title: '',
    }
  }

  componentDidMount () {
    this._isMounted = true;
    this._isMounted && this.setState({
      title: "Préférences utilisateur",
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render () {
    const { classes, open, onClose, fullScreen, keepMounted, ...others } = this.props;
    return (
      <Dialog
        keepMounted={keepMounted}
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        title={this.state.title}
      >
        <EditUserPreferences
          fixedCtrl={true}
          {...others}
        />
      </Dialog>
    )
  }
}

const styles = theme => ({});

DialogEditUserPreferences.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogEditUserPreferences);
